import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { TrashView } from "@/features/trash/components/trash-view";

// F4-A: papelera (restore-only; la purga es del job del servidor).
export const trashRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/trash",
  component: TrashView,
});
